import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HippoUtilsService } from '@hippo/services/utils';
import { lastValueFrom, Observable, of, switchMap, throwError } from 'rxjs';
import { UserService } from '../services/user.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
    private _authenticated: boolean = false;

    constructor(
        private _httpClient: HttpClient,
        private userService: UserService
    ) {}

    resetPassword(
        initials: string,
        password: string,
        language: string = 'de'
    ): Observable<any> {
        const formData = new FormData();
        formData.append('submit_option', 'opt_new_login');
        formData.append('submit_iso_code', language);
        formData.append('initials', initials);
        formData.append('password', password);
        formData.append('password_repeat', password);

        const uid = this.userService?.user?.uid;
        if (!uid) {
            return throwError(
                () =>
                    new Error('Cannot reset password: user session not found.')
            );
        }
        return this._httpClient
            .post(
                `hippo/navigator.php?page=pages/common/Login.php&page_type=json&uid=${uid}`,
                formData
            )
            .pipe(
                switchMap((response: any) => {
                    if (response.url) {
                        const urlParams = new URLSearchParams(response.url);
                        const uid = urlParams.get('uid');
                        if (uid) {
                            localStorage.setItem('uid', uid);
                        }
                    }

                    this._authenticated = true;
                    return of(response);
                })
            );
    }

    signIn(
        email: string,
        password: string,
        language: string = 'de'
    ): Observable<any> {
        if (this._authenticated) {
            return throwError(() => new Error('User is already logged in.'));
        }

        const formData = new FormData();
        formData.append('submit_option', 'opt_login');
        formData.append('submit_iso_code', language);
        formData.append('initials', email);
        formData.append('password', password);

        return this._httpClient.post(
            'hippo/navigator.php?page=pages/common/Login.php&page_type=json',
            formData
        );
    }

    signOut(): Observable<any> {
        sessionStorage.removeItem('user');
        this._authenticated = false;

        return of(true);
    }

    check(): Observable<boolean> {
        let user = this.userService.getUser();
        if (user?.uid) {
            this._authenticated = true;
            return of(true);
        }
        this._authenticated = false;
        return of(false);
    }

    async getPhpSessionCookie(forceNew: boolean = false) {
        const phpSessionId = HippoUtilsService.getCookie('PHPSESSID');
        if (phpSessionId && !forceNew) {
            return;
        }
        // Clear stale PHP session cookie to ensure a fresh session
        if (phpSessionId) {
            HippoUtilsService.deleteCookie('PHPSESSID');
        }
        try {
            await lastValueFrom(
                this._httpClient.get('hippo/', { responseType: 'text' })
            );
        } catch (error) {}
    }
}
